import { Entity } from "../helpers/Entity"

export type ExternalLinkAttributesDto = {
    externalId: string
    integrationKey: string
}

export type ExternalLinkDto = {
    id: string
    type: string
    attributes : ExternalLinkAttributesDto
}

export default class ExternalLink implements Entity {
    private dto: ExternalLinkDto
    constructor(dto: ExternalLinkDto) {
        this.dto = dto
    }

    isLoaded() {
        return this.dto.id != ""
    }

    getId() {
        return this.dto.id
    }

    getExternalId() {
        return this.dto.attributes.externalId
    }

    getIntegrationKey(): string {
        return this.dto.attributes.integrationKey
    }

    getDto(): ExternalLinkDto {
        return this.dto
    }

}



// WEBPACK FOOTER //
// ./src/state/integration/ExternalLink.ts